module.exports = __webpack_public_path__ + "bd.no2.0e47fd45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bd.no2.jpg
// module id = 1glF
// module chunks = 0